const mutations = {
    SET_ERROR_PLATFORM_SUBSCRIPTIONS(state, payload) {
        state.error = payload;
    },
    SET_PLAN_CATALOG(state, payload) {
        state.planCatalog = payload || [];
    },
    SET_UPGRADE_PROMPT(state, payload) {
        state.upgradePrompt = payload || null;
    }
};

export default mutations;
